import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "BaseFormGroup base-form-group" }
const _hoisted_2 = {
  key: 0,
  class: "base-form-group__label"
}
const _hoisted_3 = { class: "base-form-group__label-text" }
const _hoisted_4 = {
  key: 0,
  class: "base-form-group__label-required"
}
const _hoisted_5 = { class: "base-form-group__input" }
const _hoisted_6 = {
  key: 1,
  class: "base-form-group__error"
}

import { computed } from 'vue';
import { Validation } from '@vuelidate/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseFormGroup',
  props: {
    label: {},
    required: { type: Boolean },
    validation: {},
    showError: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isError = computed(() => props.validation?.$error);

const errorText = computed(() => (
  props.validation?.$errors?.map(error => error.$message)
    .join('. ') || ''

));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", {
        isFieldError: isError.value,
        fieldErrorText: errorText.value
      })
    ]),
    (isError.value || _ctx.showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.showError)
            ? _renderSlot(_ctx.$slots, "error", {
                key: 0,
                errorText: errorText.value
              })
            : (isError.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(errorText.value), 1)
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})